(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const ACTIVE_CLASS = 'pnp-mq-builder-in-view';
  const mediaQuery = window.matchMedia(MOBILE_QUERY);
  let builderObserver;
  let observedBuilder;

  const setBuilderVisibility = (entry) => {
    document.body.classList.toggle(ACTIVE_CLASS, mediaQuery.matches && entry.isIntersecting);
  };

  const stopObserving = () => {
    builderObserver?.disconnect();
    builderObserver = undefined;
    observedBuilder = undefined;
    document.body.classList.remove(ACTIVE_CLASS);
  };

  const observeBuilder = () => {
    const builder = document.querySelector('[data-mq-builder]');

    if (!mediaQuery.matches || !builder) {
      stopObserving();
      return false;
    }

    if (builder === observedBuilder) return true;

    stopObserving();
    observedBuilder = builder;
    builderObserver = new IntersectionObserver(([entry]) => setBuilderVisibility(entry));
    builderObserver.observe(builder);
    return true;
  };

  const pageObserver = new MutationObserver(() => {
    if (!observedBuilder || !observedBuilder.isConnected) observeBuilder();
  });

  const start = () => {
    observeBuilder();
    pageObserver.observe(document.body, { childList: true, subtree: true });
    mediaQuery.addEventListener('change', observeBuilder);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
